import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import ChoiceStore from './choice-store';
import ChoiceActionsFactory from './choice-actions-factory';
import Select from 'react-select';
// Be sure to include styles at some point, probably during your bootstrapping
import 'react-select/dist/react-select.css';

export default class SelectChoices extends React.Component {    
    constructor(props) {
        super(props);
        let selectedChoice = props.question.choices.find( (choice)=>{
            return choice.selected;
        })
        this.state = selectedChoice!=null ? selectedChoice : this.getInitialState();
        this.ChoiceActions = ChoiceActionsFactory.get(props.question.questionId);
    }
    getInitialState(){
        return {
            choiceId: '',
            choiceText: '',
            selected: false
        }
    }
    componentDidMount() {
        //let $this = $(ReactDOM.findDOMNode(this));
    }
    componentDidUpdate(){
        //let $this = $(ReactDOM.findDOMNode(this));
    }
    getChoices(){       
        let choicesMap = this.props.question.choices.map( (choice,index) => {
            return {
                value: choice.choiceId,
                label: choice.choiceText,
                selected: choice.selected
            }
        });

        return choicesMap;

    }

    doChange(choice){
        const selectedId = choice!=null ? choice.value : '';
        this.props.question.choices.forEach( (choice)=>{
            choice.selected = choice.choiceId == selectedId
        })
        this.ChoiceActions.change();
        if(choice==null){
            choice = this.getInitialState();
        }
        this.setState(choice);

    }

    render() { 
        let choices = this.getChoices();
        let selectedChoice = choices.find( (choice)=>{
            return choice.selected;
        })
        if(choices.length==0) return false;
        const selectProps = {
            name: 'question-select',
            value: selectedChoice!=null ? selectedChoice.value : '',
            options: choices,
            onChange: this.doChange.bind(this)
        }

        return(
            <div className="choices-container select-choices">
                <Select {...selectProps} />
            </div>
        )
    }
}
SelectChoices.propTypes={
    question: React.PropTypes.object.isRequired
}
SelectChoices.defaultProps={
}



// WEBPACK FOOTER //
// ./medscape_modules/qna/form-components/choices/select.jsx